import React, { Component } from "react";
import { Input, SelectField, Array } from "react-invenio-forms";
import { Grid, Form, Dropdown } from "semantic-ui-react";

// Initial value for a new DSMD entry
const newDSMDEntry = {
  // Data to Knowledge Fields
  property_types: "",
  provenance: "",
  calculation_level: "",
  number_of_elements: "",
  number_of_configurations: "",
  number_of_atoms: "",

  // BioSimDB Fields
  stages: null,
  settings: null,
  observables: null,
  topology: null,
  trajectory: null,
  composition: null,
  potentials: null,
  compute: null,
  files: null,

  // BioSimDB Schema Version
  biosim_schema_version: "",
  
  // SimpNMR_DB fields
  simpnmr_software_name: "",
  simpnmr_software_version: "",
  simpnmr_charge: "",
  simpnmr_multiplicity: "",
  simpnmr_dft_functional: "",
  simpnmr_basis_set: "",
  simpnmr_solvent: "",
  simpnmr_nuclear_repulsion_energy: "",
  smiles: "",
  inchi: "",
  number_of_elements: "",
  elements: "",
  elements_ratios: "",

  // Project M fields
  elements: "",
  elements_ratios: "",
  instrument_synchrotron: "",
  instrument_beamline: "",
  instrument_calibrant: "",
  weighted_pattern_r_factor: "",
  goodness_of_fit: "",
  maximum_intensity: "",
  additive_pka_cooh: "",
  additive_pkb_nh2: "",
  additive_pkc_other: "",
  additive_pi: "",
  degree_of_crystallinity: "",


  // SimpNMR_DB fields
  simpnmr_software_name: "",
  simpnmr_software_version: "",
  simpnmr_charge: "",
  simpnmr_multiplicity: "",
  simpnmr_dft_functional: "",
  simpnmr_basis_set: "",
  simpnmr_solvent: "",
  simpnmr_nuclear_repulsion_energy: "",
  smiles: "",
  inchi: "",

  // -------------------------
  // Flow Battery Reproducibility Study (Simple Version)
  // -------------------------
  // Section 1 - Opening Questions
  fb_data_collection_phase: "",
  fb_participant_name: "",
  fb_participant_institution: "",
  fb_participant_department: "",
  fb_participant_email: "",
  fb_participant_orcid: "",
  fb_job_role: "",
  fb_experience_flow_batteries: "",
  fb_participant_identifier: "",
  fb_number_of_repeats: "",
  // Section 2 - Electrode
  fb_electrode_pretreatment_type: "",
  fb_heat_treatment_furnace_type: "",
  fb_heat_treatment_furnace_details: "",
  fb_heat_treatment_atmosphere: "",
  fb_heat_treatment_ramp_rate: "",
  fb_heat_treatment_dwell_temperature: "",
  fb_heat_treatment_dwell_time: "",
  fb_heat_treatment_cooling_method: "",
  fb_heat_treatment_cooling_details: "",
  fb_heat_treatment_batching: "",
  fb_time_between_heat_treatment_and_use: "",
  fb_electrode_storage_after_heat_treatment: "",
  fb_electrode_storage_after_receipt: "",
  // Section 3 - Membrane
  fb_membrane_storage_type: "",
  fb_membrane_storage_liquid: "",
  fb_membrane_storage_details: "",
  fb_membrane_pretreatment: "",
  fb_membrane_pretreatment_steps: "",
  fb_membrane_pretreatment_applied: "",
  fb_membrane_pretreatment_medium: "",
  fb_membrane_pretreatment_concentration: "",
  fb_membrane_pretreatment_duration: "",
  fb_membrane_pretreatment_temperature: "",
  fb_membrane_pretreatment_details: "",
  // Section 4 - Electrolyte materials
  fb_ferrocyanide_chemical_details: "",
  fb_ferrocyanide_purity: "",
  fb_ferrocyanide_supplier: "",
  fb_ferricyanide_chemical_identity: "",
  fb_ferricyanide_purity: "",
  fb_ferricyanide_supplier: "",
  fb_supporting_electrolyte_identity: "",
  fb_potassium_chloride_purity: "",
  fb_potassium_chloride_supplier: "",
  fb_water_type: "",
  fb_water_purification_system: "",
  fb_water_purification_details: "",
  fb_water_resistivity: "",
  // Section 5 - Electrolyte preparation
  fb_electrolyte_preparation_strategy: "",
  fb_electrolyte_batch_size: "",
  fb_electrolyte_storage_environment: "",
  fb_electrolyte_storage_duration: "",
  fb_electrolyte_volume_measurement_method: "",
  fb_volume_measurement_instrument: "",
  fb_reagent_purity_used: "",
  fb_reagent_purity_details: "",
  fb_water_ph_measured: "",
  fb_water_ph_value: "",
  fb_electrolyte_ph_measured: "",
  fb_electrolyte_ph_value: "",
  // Section 6 - Cell and equipment setup
  fb_electrode_dimension_method: "",
  fb_electrode_cutting_method: "",
  fb_potentiostat_usage: "",
  fb_potentiostat_manufacturer: "",
  fb_potentiostat_model: "",
  fb_potentiostat_manufacturer_cycling: "",
  fb_potentiostat_model_cycling: "",
  fb_potentiostat_manufacturer_polarisation: "",
  fb_potentiostat_model_polarisation: "",
  fb_potentiostat_manufacturer_impedance: "",
  fb_potentiostat_model_impedance: "",
  fb_potentiostat_calibration_frequency: "",
  fb_potentiostat_calibration_method: "",
  fb_connection_method: "",
  fb_electrical_connection_scheme: "",
  fb_potentiostat_cable_length: "",
  fb_potentiostat_cable_type: "",
  fb_potentiostat_cable_shielding: "",
  fb_number_of_pumps: "",
  fb_pump_type: "",
  fb_pump_manufacturer: "",
  fb_pump_model: "",
  fb_reservoir_material: "",
  fb_reservoir_type: "",
  fb_reservoir_volume: "",
  fb_tubing_material: "",
  fb_tubing_manufacturer: "",
  fb_tubing_inner_diameter: "",
  fb_wetted_fitting_materials: "",
  fb_other_wetted_materials: "",
  fb_electrolyte_volume_used: "",
  fb_impedance_reservoir_config: "",
  fb_polarisation_reservoir_config: "",
  fb_electrolyte_flow_rate: "",
  // Section 7 - Experimental methods and observations
  fb_temperature_control: "",
  fb_laboratory_temperature: "",
  fb_pump_flow_rate_calibrated: "",
  fb_calibration_with_cell: "",
  fb_calibration_fluid: "",
  fb_pump_recalibrated: "",
  fb_pump_calibration_method: "",
  fb_leak_test_performed: "",
  fb_leak_test_duration: "",
  fb_leak_test_flow_rate: "",
  fb_break_in_performed: "",
  fb_break_in_duration: "",
  fb_break_in_flow_rate: "",
  fb_cell_assembly_issues: "",
  fb_additional_experiments: "",
  fb_additional_experiment_rationale: "",
  fb_leakage_location: "",
  fb_repeats_techniques_repeated: "",
  fb_repeat_method: "",
  fb_electrolyte_leakage_reported: "",
  fb_leakage_description: "",
  fb_leak_severity: "",
  fb_leakage_volume: "",
  fb_typical_group_practice_leaks: "",
  fb_electrolyte_stirring: "",
  fb_reservoir_stirring_method: "",
  fb_stirring_rate: "",
  fb_electrolyte_sparging: "",
  fb_sparging_gas: "",
  fb_gas_humidification: "",
  fb_sparging_application: "",
  fb_sparging_gas_flow_rate: "",
  fb_polarisation_beyond_limits: "",
  fb_max_current_density: "",
  fb_max_current_density_rationale: "",
  fb_impedance_control_mode: "",
  fb_impedance_technique_rationale: "",
  fb_impedance_parameters_basis: "",
  fb_reservoir_tubing_changes: "",
  fb_observable_changes_disassembly: "",
  fb_components_affected: "",
  fb_discolouration_nature: "",
  fb_additional_tests_performed: "",
  // Section 8 - Closing questions
  fb_consent_public_display: "",
  fb_consent_clarification: "",
  fb_additional_protocol_details: "",
  fb_additional_documentation_uploaded: "",
  // AFM_DB
  afm_instrument: "",
  afm_imaging_mode: "",
  afm_probe_type: "",
  afm_imaging_conditions: "",
  afm_sample_type: "",
  afm_chemical_formula: "",
  afm_processing_software: "",
  // TEM-ParticlesDB Fields
  tem_manufacturer: "",
  tem_source_type: "",
  tem_detector_type: "",
  tem_detector_dimensions: "",
  tem_pixel_size_nm: "",

  // BenchmarkSet1500
  bs1500_es_s1_sa_casscf: "",
  bs1500_es_s2_sa_casscf: "",
  bs1500_et_t1_sa_casscf: "",
  bs1500_et_t2_sa_casscf: "",
  bs1500_fs1_sa_casscf: "",
  bs1500_fs2_sa_casscf: "",
  bs1500_es_s1_sc_nevpt2: "",
  bs1500_es_s2_sc_nevpt2: "",
  bs1500_et_t1_sc_nevpt2: "",
  bs1500_et_t2_sc_nevpt2: "",
  bs1500_fs1_sc_nevpt2: "",
  bs1500_fs2_sc_nevpt2: "",
  bs1500_ccdc_id: "",
  bs1500_smiles: "",
  bs1500_inchi: "",
  bs1500_molecular_formula: "",
  bs1500_number_of_atoms: "",
  bs1500_ccdc_url: "",
  bs1500_electronic_structure_methodology: "",
  bs1500_correlation_method: "",
  bs1500_active_space: "",
  bs1500_basis_set: "",
  bs1500_excited_state_software: "",
  bs1500_ground_state_functional: "",
  bs1500_ground_state_basis_set: "",

  // AI Ready Data Sets
  airds_data_collection: "",
  airds_data_collection_type: "",
  airds_data_collection_missing_data: "",
  airds_data_collection_raw_data: "",
  airds_data_annotation_protocol: "",
  airds_data_annotation_platform: "",
  airds_data_annotation_analysis: "",
  airds_annotator_demographics: "",
  airds_machine_annotation_tools: "",
  airds_annotations_per_item: "",
  airds_data_preprocessing_protocol: "",
  airds_data_manipulation_protocol: "",
  airds_data_imputation_protocol: "",
  airds_data_use_cases: "",
  airds_data_biases: "",
  airds_personal_sensitive_information: "",
  airds_data_social_impact: "",
  airds_data_limitations: "",
  airds_data_release_maintenance_plan: "",

  // ORKIM 
  orkim_reaction_system: "",
  orkim_catalyst: "",
  orkim_temperature_range: "",
  orkim_pressure_range: "",
  // ADEQUACY Project
  adeq_project_phase: "",
  adeq_alloy_composition: "",
  adeq_data_type: "",
  adeq_test_temperature: "",
  adeq_characterization_tool: "",

};

export class DSMD extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: "BioSim", // Default category selection
    };
  }

  // Handle dropdown selection to set category
  handleCategoryChange = (e, { value }) => {
    this.setState({ selectedCategory: value });
  };

  render() {
    const { fieldPath, icon, addButtonLabel, description, label } = this.props;
    const { selectedCategory } = this.state;

    return (
      <Form>
        {/* Category Selection Dropdown */}
        <Form.Field>
          <label htmlFor="dsmd-category-dropdown">Select Domain</label>
          <Dropdown
            id="dsmd-category-dropdown"
            selection
            options={[
              /*{ key: "biosim", value: "BioSim", text: "BioSim" },*/
              {
                key: "data-to-knowledge",
                value: "Data to Knowledge",
                text: "Data to Knowledge",
              },
              { key: "simpnmr", value: "SimpNMR_DB", text: "SimpNMR_DB" },
              { key: "project-m", value: "Project M", text: "Project M" },
              { key: "flow-battery", value: "Flow Battery", text: "Flow Battery" },
              { key: "afm", value: "AFM_DB", text: "AFM_DB" },
              { key: "tem", value: "TEM-ParticlesDB", text: "TEM-ParticlesDB" },
              { key: "bs1500", value: "BenchmarkSet1500", text: "BenchmarkSet1500" },
              { key: "airds", value: "AIReadyDataSets", text: "AIReadyDataSets" },
              { key: "orkim", value: "ORKiM", text: "ORKiM" },
              /*{ key: "ADEQ", value: "ADEQUACy-DB", text: "ADEQUACy-DB" },*/




            ]}
            placeholder="Select Domain"
            onChange={this.handleCategoryChange}
            value={selectedCategory}
            fluid
          />
        </Form.Field>

        {/* Array Field for Entries */}
        <Array
          fieldPath={fieldPath}
          label={label}
          icon={icon}
          addButtonLabel={addButtonLabel || "Add Domain Specific Metadata"}
          defaultNewValue={newDSMDEntry}
          description={description}
        >
          {({ indexPath }) => (
            <Grid>
              {/* BioSimDB Automation Notice */}
              {selectedCategory === "BioSim" && (
                <Grid.Row>
                  <Grid.Column width="16">
                    <p
                      style={{
                        fontStyle: "italic",
                        fontSize: "small",
                        color: "gray",
                      }}
                    >
                      <strong>*</strong> Any metadata labels in parentheses are
                      not compulsory.  Future versions plan to automatically
                      extract most domain-specific metadata.
                    </p>
                  </Grid.Column>
                </Grid.Row>
              )}

              {/* Data to Knowledge Fields */}
              {selectedCategory === "Data to Knowledge" && (
                <>
                  <Grid.Column width="7">
                    <Input
                      fieldPath={`${fieldPath}.${indexPath}.property_types`}
                      label="Property Types"
                      placeholder="Enter property types"
                      description="Type of property described by this Data to Knowledge model"
                    />
                  </Grid.Column>

                  <Grid.Column width="7">
                    <Input
                      fieldPath={`${fieldPath}.${indexPath}.provenance`}
                      label="Provenance"
                      placeholder="Enter provenance"
                      description="Origin of the training data for this Data to Knowledge model"
                    />
                  </Grid.Column>

                  <Grid.Column width="7">
                    <Input
                      fieldPath={`${fieldPath}.${indexPath}.calculation_level`}
                      label="Calculation Level"
                      placeholder="Enter calculation level"
                      description="Accuracy level of Data to Knowledge calculations"
                    />
                  </Grid.Column>

                  <Grid.Column width="7">
                    <Input
                      fieldPath={`${fieldPath}.${indexPath}.number_of_elements`}
                      label="Number of Elements"
                      placeholder="Enter number of elements"
                      description="Total number of distinct chemical elements"
                    />
                  </Grid.Column>

                  <Grid.Column width="7">
                    <Input
                      fieldPath={`${fieldPath}.${indexPath}.number_of_configurations`}
                      label="Number of Configurations"
                      placeholder="Enter number of configurations"
                      description="Total number of training data configurations"
                    />
                  </Grid.Column>

                  <Grid.Column width="7">
                    <Input
                      fieldPath={`${fieldPath}.${indexPath}.number_of_atoms`}
                      label="Number of Atoms"
                      placeholder="Enter number of atoms"
                      description="Total number of atoms in the system"
                    />
                  </Grid.Column>
                </>
              )}

              {/* BioSimDB Fields */}
              {selectedCategory === "BioSim" && (
                <>
                  {[
                    [
                      "stages",
                      "Simulation Stages",
                      "{}",
                      "Setup, minimisation, equilibration, production and analysis metadata",
                    ],
                    [
                      "settings",
                      "Simulation Settings",
                      "{}",
                      "Ensemble, integrator, thermostat, barostat and interaction settings",
                    ],
                    [
                      "observables",
                      "Simulation Observables",
                      "{}",
                      "Simulation averages and measured properties",
                    ],
                    [
                      "topology",
                      "Topology Metadata",
                      "{}",
                      "Particle and connectivity information",
                    ],
                    [
                      "trajectory",
                      "Trajectory Metadata",
                      "{}",
                      "Simulation box and trajectory output information",
                    ],
                    [
                      "composition",
                      "System Composition",
                      "{}",
                      "System counts and molecule identifiers",
                    ],
                    [
                      "potentials",
                      "Potential Metadata",
                      "{}",
                      "Force field and potential information",
                    ],
                    [
                      "compute",
                      "Computational Environment",
                      "{}",
                      "Hardware, software and performance metadata",
                    ],
                    [
                      "files",
                      "File Metadata",
                      "{}",
                      "Associated simulation files",
                    ],
                    [
                      "biosim_schema_version",
                      "BioSim Schema Version",
                      "1.0",
                      "Version of the BioSimDB schema",
                    ],
                  ].map(([key, fieldLabel, placeholder, desc]) => (
                    <Grid.Column width="7" key={key}>
                      <Input
                        fieldPath={`${fieldPath}.${indexPath}.${key}`}
                        label={fieldLabel}
                        placeholder={placeholder}
                        description={desc}
                      />
                    </Grid.Column>
                  ))}
                </>
              )}
              {/* AFM_DB Fields */}
              {selectedCategory === "AFM_DB" && (
              <>
                {[
                  [
                    "afm_instrument",
                    "Instrument",
                    "Bruker FastScanBio",
                    "Name of the instrument you used to collect the data",
                  ],
                  [
                    "afm_imaging_mode",
                    "Imaging mode",
                    "Tapping Mode",
                    "Imaging mode that the data was collected in",
                  ],
                  [
                    "afm_probe_type",
                    "Probe type",
                    "Bruker FastScanD",
                    "Name of the AFM probe used to collect the data",
                  ],
                  [
                    "afm_imaging_conditions",
                    "Imaging conditions",
                    "Liquid",
                    'Imaging conditions "air" or "liquid"',
                  ],
                  [
                    "afm_sample_type",
                    "Sample type",
                    "Polymer/Perovskite/DNA etc.",
                    "General sample type",
                  ],
                  [
                    "afm_chemical_formula",
                    "Chemical formula (if applicable)",
                    "(C8H8)n",
                    "Chemical formula of sample imaged (if applicable)",
                  ],
                  [
                    "afm_processing_software",
                    "Processing software",
                    "TopoStats",
                    "Name of the software used to process the data",
                  ],
                ].map(([key, fieldLabel, placeholder, desc]) => (
              <Grid.Column width="7" key={key}>
              <Input
                      fieldPath={`${fieldPath}.${indexPath}.${key}`}
                      label={fieldLabel}
                      placeholder={placeholder}
                      description={desc}
                    />
              </Grid.Column>
                ))}
              </>
              )}
              {/* TEM-ParticlesDB Fields */}
              {selectedCategory === "TEM-ParticlesDB" && (
              <>
                {[
                  [
                    "tem_manufacturer",
                    "Manufacturer",
                    "JEOL, Thermo Fisher",
                    "Manufacturer of the TEM instrument used.",
                  ],
                  [
                    "tem_source_type",
                    "Source type",
                    "Tungsten, LaB6, field emission, cold field emission",
                    "Electron source type used.",
                  ],
                  [
                    "tem_detector_type",
                    "Detector type",
                    "Gatan, Electron Detector, Quantum Detectors",
                    "Electron detector type used.",
                  ],
                  [
                    "tem_detector_dimensions",
                    "Detector dimensions",
                    "2048 x 2048",
                    "Detector dimensions in pixels.",
                  ],
                  [
                    "tem_pixel_size_nm",
                    "Pixel size (nm)",
                    "1",
                    "Resolution (pixel size) in nanometres to which the images were obtained. Only if this is constant to all the files.",
                  ],
                ].map(([key, fieldLabel, placeholder, desc]) => (
              <Grid.Column width="7" key={key}>
              <Input
                      fieldPath={`${fieldPath}.${indexPath}.${key}`}
                      label={fieldLabel}
                      placeholder={placeholder}
                      description={desc}
                    />
              </Grid.Column>
                ))}
              </>
              )}
              {/* SimpNMR_DB Fields */}
              {selectedCategory === "SimpNMR_DB" && (
              <>
                {[
                  [
                    "simpnmr_software_name",
                    "Name of the software",
                    "ORCA",
                    "Name of the quantum chemistry software, e.g. ORCA or Gaussian",
                  ],
                  [
                    "simpnmr_software_version",
                    "Software version",
                    "6.1.0",
                    "Version of quantum chemistry software",
                  ],
                  [
                    "simpnmr_charge",
                    "Charge",
                    "0",
                    "Charge of the metal complex used in the calculation",
                  ],
                  [
                    "simpnmr_multiplicity",
                    "Multiplicity",
                    "2",
                    "Multiplicity (2S+1) used in the calculation",
                  ],
                  [
                    "simpnmr_dft_functional",
                    "DFT functional",
                    "B3LYP",
                    "Name of the DFT functional",
                  ],
                  [
                    "simpnmr_basis_set",
                    "Basis set information",
                    "6-311G",
                    "Name of the basis set",
                  ],
                  [
                    "simpnmr_solvent",
                    "Solvent (if present)",
                    "water",
                    "Implicit solvent name",
                  ],
                  [
                    "simpnmr_nuclear_repulsion_energy",
                    "Nuclear repulsion energy",
                    "-124.556785",
                    "Nuclear repulsion energy in Hartree",
                  ],
                  [
                    "chemical_formula_descriptive",
                    "Descriptive chemical formula",
                    "DyC27N6H27O6",
                    "The chemical formula for a structure as a string in a form chosen by the implementation. Please see: https://schemas.optimade.org/defs/v1.2/properties/optimade/structures/chemical_formula_descriptive for property definition.",
                  ],
                  [
                    "smiles",
                    "SMILES",
                    "O=C(O)CCCCC(=O)O",
                    "SMILES (Simplified Molecular Input Line Entry Specification) representation of the additive",
                  ],
                  [
                    "inchi",
                    "InChI",
                    "InChI=1S/C6H10O4/c7-5(8)3-1-2-4-6(9)10/h1-4H2,(H,7,8)(H,9,10)",
                    'The standard InChI identifier as defined by the InChI Trust (https://www.inchi-trust.org).  The value MUST start with "InChI=".',
                  ],
                  [
                    "number_of_elements",
                    "Number of elements",
                    "3",
                    "Number of different elements in the structure as an integer. Please see: https://schemas.optimade.org/defs/v1.2/properties/optimade/structures/nelements for property definition.",
                  ],
                  [
                    "elements",
                    "Elements",
                    '["Al", "Si", "O"]',
                    "The chemical symbols of the different elements present in the structure.",
                  ],
                  [
                    "elements_ratios",
                    "Elements ratios",
                    "[0.2, 0.2, 0.6]",
                    "Relative proportions of different elements in the structure.",
                  ],
                ].map(([key, fieldLabel, placeholder, desc]) => (
              <Grid.Column width="7" key={key}>
              <Input
                      fieldPath={`${fieldPath}.${indexPath}.${key}`}
                      label={fieldLabel}
                      placeholder={placeholder}
                      description={desc}
                    />
              </Grid.Column>
                ))}
              </>
              )}
              {/* ORKiM Fields */}
              {selectedCategory === "ORKiM" && (
                <>
                  {[
                    [
                      "orkim_reaction_system",
                      "Reaction system",
                      "Oligomerization",
                      "Name of the reacting process that the mechanism is relevant for",
                    ],
                    [
                      "orkim_catalyst",
                      "Catalyst",
                      "ZSM-5",
                      "Name of the catalyst",
                    ],
                    [
                      "orkim_temperature_range",
                      "Temperature range",
                      "483-523 K",
                      "Temperature range of the process",
                    ],
                    [
                      "orkim_pressure_range",
                      "Pressure range",
                      "122-320 kPa",
                      "Pressure range of the process",
                    ],
                  ].map(([key, fieldLabel, placeholder, desc]) => (
                    <Grid.Column width="7" key={key}>
                      <Input
                        fieldPath={`${fieldPath}.${indexPath}.${key}`}
                        label={fieldLabel}
                        placeholder={placeholder}
                        description={desc}
                      />
                    </Grid.Column>
                  ))}
                </>
              )}
              {/* ADEQ Fields */}
              {selectedCategory === "ADEQUACy-DB" && (
              <>
                {[
                  [
                    "adeq_project_phase",
                    "Project Phase",
                    "Select phase...",
                    "Indicate which phase of the project this data belongs to (Thermodynamic Modelling (Thermo-Calc), HT-PVD, or Mechanical Testing & DIC).",
                    "select",
                    [
                      { text: "Phase 1: Thermodynamic Modelling (Thermo-Calc)", value: "Thermodynamic Modelling (Thermo-Calc)" },
                      { text: "Phase 2: HT-PVD", value: "HT-PVD" },
                      { text: "Phase 3: Mechanical Testing & DIC", value: "Mechanical Testing & DIC" },
                    ],
                  ],
                  [
                    "adeq_alloy_composition",
                    "Alloy Composition",
                    "Fe-Cr-Ni-Mn-Mo",
                    "List the elemental composition targeted or tested in this sample.",
                    "input",
                  ],
                  [
                    "adeq_data_type",
                    "Data Type",
                    "Material Characterisation Data",
                    "Specify the exact type of data output (e.g., EDX maps, XRD, EBSD, DIC, load-displacement).",
                    "input",
                  ],
                  [
                    "adeq_test_temperature",
                    "Test Temperature",
                    "750°C",
                    "The temperature at which the testing or synthesis occurred.",
                    "input",
                  ],
                  [
                    "adeq_characterization_tool",
                    "Characterization Tool",
                    "SEM / Thermo-Calc",
                    "The instrument or software used to generate the output files.",
                    "input",
                  ],
                ].map(([key, fieldLabel, placeholder, desc, type, options]) => (
              <Grid.Column width="7" key={key}>
                    {type === "select" ? (
              <>
              <SelectField
                          fieldPath={`${fieldPath}.${indexPath}.${key}`}
                          label={fieldLabel}
                          placeholder={placeholder}
                          options={options}
                        />
              <small
                          className="helptext"
                          style={{
                            color: "rgba(0,0,0,.6)",
                            display: "block",
                            marginLeft: 0,
                            paddingLeft: 0,
                            marginTop: "0.25rem",
                          }}
              >
                          {desc}
              </small>
              </>
                    ) : (
              <Input
                        fieldPath={`${fieldPath}.${indexPath}.${key}`}
                        label={fieldLabel}
                        placeholder={placeholder}
                        description={desc}
                      />
                    )}
              </Grid.Column>
                ))}
              </>
              )}
              {/* BenchmarkSet1500 Fields */}
              {selectedCategory === "BenchmarkSet1500" && (
              <>
                {[
                  ["bs1500_es_s1_sa_casscf","E(S1) SA-CASSCF","4.17025","SA-CASSCF computed first excited singlet state / eV"],
                  ["bs1500_es_s2_sa_casscf","E(S2) SA-CASSCF","5.33914","SA-CASSCF computed second excited singlet state / eV"],
                  ["bs1500_et_t1_sa_casscf","E(T1) SA-CASSCF","3.86876","SA-CASSCF computed first excited triplet state / eV"],
                  ["bs1500_et_t2_sa_casscf","E(T2) SA-CASSCF","3.94532","SA-CASSCF computed second excited triplet state / eV"],
                  ["bs1500_fs1_sa_casscf","f(S1) SA-CASSCF","0.00016","SA-CASSCF computed oscillator strength of the first singlet excitation"],
                  ["bs1500_fs2_sa_casscf","f(S2) SA-CASSCF","0.01994","SA-CASSCF computed oscillator strength of the second singlet excitation"],
                  ["bs1500_es_s1_sc_nevpt2","E(S1) SC-NEVPT2","4.17025","SC-NEVPT2 computed first excited singlet state / eV"],
                  ["bs1500_es_s2_sc_nevpt2","E(S2) SC-NEVPT2","5.33914","SC-NEVPT2  computed second excited singlet state / eV"],
                  ["bs1500_et_t1_sc_nevpt2","E(T1) SC-NEVPT2","3.86876","SC-NEVPT2 computed first excited triplet state / eV"],
                  ["bs1500_et_t2_sc_nevpt2","E(T2) SC-NEVPT2","3.94532","SC-NEVPT2 computed second excited triplet state / eV"],
                  ["bs1500_fs1_sc_nevpt2","f(S1) SC-NEVPT2","0.00016","SC-NEVPT2 computed oscillator strength of the first singlet excitation"],
                  ["bs1500_fs2_sc_nevpt2","f(S2) SC-NEVPT2","0.01994","SC-NEVPT2 computed oscillator strength of the second singlet excitation"],
                  ["bs1500_ccdc_id","CCDC ID","ABAROL","Cambridge Crystallographic Data Centre (CCDC) structure identifier"],
                  ["smiles","SMILES","S1/C(=C/2\SC3=…","Canonical SMILES representation of molecule"],
                  ["inchi","InChI","InChI=1S/C2H6O/c1-2-3/h3H,2H2,1H3","InChi Key representation of molecule"],
                  ["bs1500_molecular_formula","Molecular Formula","C10H8S6","Molecular formula"],
                  ["number_of_atoms","Number of Atoms","24","Total number of atoms"],
                  ["bs1500_ccdc_url","CCDC URL","https://www.ccdc.c...","Link to CCDC entry"],
                  ["bs1500_electronic_structure_methodology","Electronic structure methodology","SA-CASSCF","Primary electronic structure method used for multireference excited states calculation"],
                  ["bs1500_correlation_method","Correlation method","SC-NEVPT2","Correlation method used for multireference excited states calculation"],
                  ["bs1500_active_space","Active Space","8,8","Active electrons and orbitals used for multireference excited states calculation"],
                  ["bs1500_basis_set","Basis Set","Def2-TZVP","Basis set used for multireference excited states calculation"],
                  ["bs1500_excited_state_software","Excited State software","ORCA","Software used for multireference excited states calculation"],
                  ["bs1500_ground_state_functional","Ground state functional","B3LYP","Functional used for ground state geometry optimisation"],
                  ["bs1500_ground_state_basis_set","Ground state basis set","6-31G*","Basis set used for ground state geometry optimisation"],
                ].map(([key, label, placeholder, desc]) => (
              <Grid.Column width="7" key={key}>
              <Input
                      fieldPath={`${fieldPath}.${indexPath}.${key}`}
                      label={label}
                      placeholder={placeholder}
                      description={desc}
                    />
              </Grid.Column>
                ))}
              </>
              )}
              {/* AIReadyDataSets Fields */}
              {selectedCategory === "AIReadyDataSets" && (
              <>
                {[
                  ["airds_data_collection", "Data Collection", "The first part of the corpus, accounting for 62% of the final dataset size (in bytes), is made up of…", "Explain the key stages of the data collection process to improve understanding of potential users"],
                  ["airds_data_collection_type", "Data Collection Type", `["Experiments", "Surveys", "Secondary Data analysis", "Physical data collection", "Direct measurement", "Document analysis", "Manual Human Curator", "Software Collection", "Experiments", "Web Scraping", "Web API", "Focus groups", "Self-reporting", "Customer feedback data", "User-generated content data", "Passive Data Collection"]`, "Define the data collection type."],
                  ["airds_data_collection_missing_data", "Data Collection Missing Data", "Not applicable", "Description of missing data in structured/unstructured form"],
                  ["airds_data_collection_raw_data", "Data Collection Raw Data", "Imagery is from V1.4 of Harmonized Landsat and Sentinel-2 (HLS). A full description and access to HL…", "Description of the raw data i.e. source of the data"],
                  ["airds_data_annotation_protocol", "Data Annotation Protocol", "The annotation task included the following six sets of questions: Q1: addresses the whole conversati…", "Description of annotations (labels, ratings) produced, including how these were created or authored - Annotation Workforce Type, Annotation Characteristic(s), Annotation Description(s), Annotation Task(s), Annotation Distribution(s)"],
                  ["airds_data_annotation_platform", "Data Annotation Platform", `["Crowdworker annotators with task specific UI"]`, "Platform, tool, or library used to collect annotations by human annotators"],
                  ["airds_data_annotation_analysis", "Data Annotation Analysis", `["Initial recruitment of 123 raters for the DICES-350 dataset, after all annotation tasks were compl…"]`, "Considerations related to the process of converting the raw annotations into the labels that are ultimately packaged in a dataset - Uncertainty or disagreement between annotations on each instance as a signal in the dataset, analysis of systematic disagreements between annotators of different socio demographic group, how the final dataset annotations will relate to individual annotator responses"],
                  ["airds_annotator_demographics", "Annotator Demographics", `["DICES-350 was annotated by a pool of 104 raters. The rater breakdown for this pool is: 57 women an…"]`, "List of demographics specifications about the annotators"],
                  ["airds_machine_annotation_tools", "Machine Annotation Tools", `["Not applicable"]`, "List of software used for data annotation ( e.g. concept extraction, NER, and additional characteristics of the tools used for annotation to allow for replication or extension)"],
                  ["airds_annotations_per_item", "Annotations Per Item", "350 conversations were rated along 16 safety criteria, i.e.,104 unique ratings per conversation.", "Number of human labels per dataset item"],
                  ["airds_data_preprocessing_protocol", "Data Preprocessing Protocol", `["Near-deduplication was implemented in the pre-processing pipeline on top of exact deduplication. T…"]`, "Description of the steps that were required to bring collected data to a state that can be processed by an ML model/algorithm, e.g. filtering out incomplete entries etc."],
                  ["airds_data_manipulation_protocol", "Data Manipulation Protocol", "Deduplication: we applied substring deduplication (Lee et al., 2022) based on Suffix Array (Manber a…", "Description of data manipulation process if applicable"],
                  ["airds_data_imputation_protocol", "Data Imputation Protocol", "Not applicable", "Description of data imputation process if applicable"],
                  ["airds_data_use_cases", "Data Use Cases", `["The dataset is to be used as a shared resource and benchmark that respects diverse perspectives du…"]`, "training, testing, validation, development or production use, fine tuning, others (please specify), usage guidelines, recommended uses, etc."],
                  ["airds_data_biases", "Data Biases", `["Dataset includes multiple sub-ratings which specify the type of safety concern, such as type of ha…"]`, "Involves understanding the potential risks associated with data usage and to prevent unintended and potentially harmful consequences that may arise from using models trained on or evaluated with the respective data"],
                  ["airds_personal_sensitive_information", "Personal Sensitive Information", `["We used a rule-based approach leveraging regular expressions (Appendix C). The elements redacted wer…"]`, "Personal and sensitive information, if contained within the dataset, can play an important role in the mitigation of any risks and the responsible use of the datasets"],
                  ["airds_data_social_impact", "Data Social Impact", "The authors emphasized that the BigScience Research Workshop, under which the dataset was developed,…", "Discussion of social impact, if applicable"],
                  ["airds_data_limitations", "Data Limitations", `["The preprocessing removes some categories of PII but is still far from exhaustive, and the nature …"]`, "Known limitations - Data generalization limits (e.g related to data distribution, data quality issues, or data sources) and on-recommended uses."],
                  ["airds_data_release_maintenance_plan", "Data Release Maintenance Plan", `["One off release - no updates planned"]`, "Data release maintenance. Versioning information in terms of the updating timeframe, the maintainers, and the deprecation policies."],
                ].map(([key, label, placeholder, desc]) => (
              <Grid.Column width="12" key={key}>
              <Input
                      fieldPath={`${fieldPath}.${indexPath}.${key}`}
                      label={label}
                      placeholder={placeholder}
                      description={desc}
                    />
              </Grid.Column>
                ))}
              </>
              )}
              {/* Project M fields */}
              {selectedCategory === "Project M" && (
                <>
                  <Grid.Column width="7">
                    <Input
                      fieldPath={`${fieldPath}.${indexPath}.elements`}
                      label="Elements"
                      placeholder={`["Al", "Si", "O"]`}
                      description={
 'The chemical symbols of the different elements present in the structure.'
}
                    />
                  </Grid.Column>

                  <Grid.Column width="7">
                    <Input
                      fieldPath={`${fieldPath}.${indexPath}.elements_ratios`}
                      label="Elements ratios"
                      placeholder="[0.2, 0.2, 0.6]"
                      description={
 'Relative proportions of different elements in the structure.'
}
                    />
                  </Grid.Column>

                  <Grid.Column width="7">
                    <Input
                      fieldPath={`${fieldPath}.${indexPath}.instrument_synchrotron`}
                      label="Instrument synchrotron"
                      placeholder="Diamond Light Source (https://www.diamond.ac.uk/Home.html)"
                      description="Synchrotron used to collect the data."
                    />
                  </Grid.Column>

                  <Grid.Column width="7">
                    <Input
                      fieldPath={`${fieldPath}.${indexPath}.instrument_beamline`}
                      label="Instrument beamline"
                      placeholder="I11 (https://www.diamond.ac.uk/Instruments/Crystallography/I11/layout.html)"
                      description="Beamline used to collect the data."
                    />
                  </Grid.Column>
                  <Grid.Column width="7">
                    <Input
                      fieldPath={`${fieldPath}.${indexPath}.instrument_calibrant`}
                      label="Instrument calibrant"
                      placeholder="Si640c (https://tsapps.nist.gov/srmext/certificates/archives/640c.pdf)"
                      description="Calibrant used to determine instrument parameters."
                    />
                  </Grid.Column>


                  {/* -------- Instrument -------- */}
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.instrument_wavelength`}
                    label="Instrument wavelength"
                    placeholder="0.82571125"
                    description="Wavelength (in Angstroms) of X-rays used to collect data."
                  />
                  </Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.instrument_detector`}
                    label="Instrument detector"
                    placeholder="Mythen II position sensitive detector"
                    description="Detector used to collect the data."
                  />
                  </Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.instrument_zero_error`}
                    label="Instrument zero error"
                    placeholder="0.003276786"
                    description="Zero error of detector, in ° (degrees)"
                  />
                  </Grid.Column>
                  <Grid.Column width="12">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.instrument_zero_error_info`}
                    label="Instrument zero error - further information"
                    placeholder="Calibration of Si640c dataset"
                    description="Details about the calibration of the zero error of detector."
                  />
                  </Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.instrument_axial_divergence`}
                    label="Instrument axial divergence"
                    placeholder="3.26757331"
                    description="Value for simple axial divergence model due to mythen-style detector, in ° (degrees)."
                  />
                  </Grid.Column>
                  {/* -------- Additive -------- */}
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_label`}
                    label="Additive - label"
                    placeholder="AdiAci"
                    description="Short form of additive name."
                  />
                  </Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_concentration`}
                    label="Additive - concentration"
                    placeholder="0.2"
                    description="Ratio of additive: Ca ion concentration used."
                  />
                  </Grid.Column>
                  <Grid.Column width="12">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_chebi_url`}
                    label="Additive - ChEBI URL"
                    placeholder="https://www.ebi.ac.uk/chebi/CHEBI:30832"
                    description="URL to ChEBI entry which matches the additive molecule."
                  />
                  </Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_name`}
                    label="Additive - name"
                    placeholder="adipic acid"
                    description="Common name of additive molecule."
                  />
                  </Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_iupac_name`}
                    label="Additive - IUPAC name"
                    placeholder="hexanedioic acid"
                    description="Preferred IUPAC name of the additive."
                  />
                  </Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_formula`}
                    label="Additive - formula"
                    placeholder="C6H10O4"
                    description="Molecular formula of additive."
                  />
                  </Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_mass`}
                    label="Additive - mass"
                    placeholder="146.142"
                    description="Formula mass of additive molecule."
                  />
                  </Grid.Column>
                  <Grid.Column width="12">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_canonical_smiles`}
                    label="Additive - canonical SMILES"
                    placeholder="O=C(O)CCCCC(=O)O"
                    description="Canonical SMILES representation of the additive."
                  />
                  </Grid.Column>
                  <Grid.Column width="12">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_standard_inchi`}
                    label="Additive - standard InChI"
                    placeholder="InChI=1S/C6H10O4/..."
                    description="Standard InChI identifier of the structure."
                  />
                  </Grid.Column>
                  <Grid.Column width="12">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_standard_inchikey`}
                    label="Additive - standard InChIKey"
                    placeholder="WNLRTRBMVRJNCN-UHFFFAOYSA-N"
                    description="Standard InChIKey identifier of the structure."
                  />
                  </Grid.Column>
                  <Grid.Column width="12">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_chebi_class_urls`}
                    label="Additive - ChEBI molecule class URLs"
                    placeholder='["https://www.ebi.ac.uk/chebi/CHEBI:189840", "https://www.ebi.ac.uk/chebi/CHEBI:28383"]'
                    description='URLs of ChEBI classes which the additive molecule belongs to (via an "is a" relationship).'
                  />
                  </Grid.Column>
                  <Grid.Column width="12">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_chebi_class_names`}
                    label="Additive - ChEBI molecule class names"
                    placeholder='["dicarboxylic fatty acid", "?,?-dicarboxylic acid"]'
                    description='Names of ChEBI classes which the additive molecule belongs to (via an "is a" relationship).'
                  />
                  </Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_pka_cooh`}
                    label="Additive – pKa (COOH group)"
                    placeholder="2.03"
                    description="Negative of the logarithm of the acid dissociation constants for the COOH groups (at 25 degrees C)."
                  />
                  </Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_pkb_nh2`}
                    label="Additive – pKb (NH2 group)"
                    placeholder="9.01"
                    description="Negative of the logarithm of the acid dissociation constants for the NH2 groups (at 25 degrees C)."
                  />
                  </Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_pkc_other`}
                    label="Additive – pKc (other group)"
                    placeholder="12.1"
                    description="Negative of the logarithm of the acid dissociation constants for other groups (at 25 degrees C)."
                  />
                  </Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.additive_pi`}
                    label="Additive – pI"
                    placeholder="10.76"
                    description="pH at the isoelectric point."
                  />
                  </Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.degree_of_crystallinity`}
                    label="Degree of Crystallinity"
                    placeholder="59.33704"
                    description="Percentage of area (after background subtraction) that comes from crystalline phases."
                  />
                  </Grid.Column>
                  {/* -------- Calcite -------- */}
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.calcite_phase_present`}
                    label="Calcite phase present"
                    placeholder="TRUE"
                    description="Indicates whether the calcite crystalline phase is present."
                  />
                  </Grid.Column>
                  <Grid.Column width="7"><Input fieldPath={`${fieldPath}.${indexPath}.calcite_unit_cell_length_a`} label="Calcite unit-cell length a" placeholder="10" description="Unit-cell length a in angstroms." /></Grid.Column>
                  <Grid.Column width="7"><Input fieldPath={`${fieldPath}.${indexPath}.calcite_unit_cell_length_b`} label="Calcite unit-cell length b" placeholder="10" description="Unit-cell length b in angstroms." /></Grid.Column>
                  <Grid.Column width="7"><Input fieldPath={`${fieldPath}.${indexPath}.calcite_unit_cell_length_c`} label="Calcite unit-cell length c" placeholder="10" description="Unit-cell length c in angstroms." /></Grid.Column>
                  <Grid.Column width="7"><Input fieldPath={`${fieldPath}.${indexPath}.calcite_unit_cell_angle_alpha`} label="Calcite unit-cell angle alpha" placeholder="10" description="Unit-cell angle alpha in degrees." /></Grid.Column>
                  <Grid.Column width="7"><Input fieldPath={`${fieldPath}.${indexPath}.calcite_unit_cell_angle_beta`} label="Calcite unit-cell angle beta" placeholder="10" description="Unit-cell angle beta in degrees." /></Grid.Column>
                  <Grid.Column width="7"><Input fieldPath={`${fieldPath}.${indexPath}.calcite_unit_cell_angle_gamma`} label="Calcite unit-cell angle gamma" placeholder="10" description="Unit-cell angle gamma in degrees." /></Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.calcite_weight_percentage`}
                    label="Calcite weight percentage"
                    placeholder="87.83"
                    description="Weight percentage of the Calcite phase."
                  />
                  </Grid.Column>
                  {/* -------- Vaterite -------- */}
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.vaterite_phase_present`}
                    label="Vaterite phase present"
                    placeholder="TRUE"
                    description="Indicates whether the vaterite crystalline phase is present."
                  />
                  </Grid.Column>
                  <Grid.Column width="7"><Input fieldPath={`${fieldPath}.${indexPath}.vaterite_unit_cell_length_a`} label="Vaterite unit-cell length a" placeholder="10" description="Unit-cell length a in angstroms." /></Grid.Column>
                  <Grid.Column width="7"><Input fieldPath={`${fieldPath}.${indexPath}.vaterite_unit_cell_length_b`} label="Vaterite unit-cell length b" placeholder="10" description="Unit-cell length b in angstroms." /></Grid.Column>
                  <Grid.Column width="7"><Input fieldPath={`${fieldPath}.${indexPath}.vaterite_unit_cell_length_c`} label="Vaterite unit-cell length c" placeholder="10" description="Unit-cell length c in angstroms." /></Grid.Column>
                  <Grid.Column width="7"><Input fieldPath={`${fieldPath}.${indexPath}.vaterite_unit_cell_angle_alpha`} label="Vaterite unit-cell angle alpha" placeholder="10" description="Unit-cell angle alpha in degrees." /></Grid.Column>
                  <Grid.Column width="7"><Input fieldPath={`${fieldPath}.${indexPath}.vaterite_unit_cell_angle_beta`} label="Vaterite unit-cell angle beta" placeholder="10" description="Unit-cell angle beta in degrees." /></Grid.Column>
                  <Grid.Column width="7"><Input fieldPath={`${fieldPath}.${indexPath}.vaterite_unit_cell_angle_gamma`} label="Vaterite unit-cell angle gamma" placeholder="10" description="Unit-cell angle gamma in degrees." /></Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.vaterite_weight_percentage`}
                    label="Vaterite weight percentage"
                    placeholder="12.17"
                    description="Weight percentage of the Vaterite phase."
                  />
                  </Grid.Column>
                  {/* -------- Structure & Formula -------- */}
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.structure_id`}
                    label="Structure ID"
                    placeholder="578568-mythen_summed"
                    description="Unique identifier of the structure see https://schemas.optimade.org/defs/v1.2/properties/core/id."
                  />
                  </Grid.Column>
                  <Grid.Column width="12"><Input fieldPath={`${fieldPath}.${indexPath}.chemical_formula_descriptive`} label="Descriptive chemical formula" placeholder="Ca CO3" description="The chemical formula for a structure as a string in a form chosen by the implementation. Please see: https://schemas.optimade.org/defs/v1.2/properties/optimade/structures/chemical_formula_descriptive for property definition." /></Grid.Column>
                  <Grid.Column width="12"><Input fieldPath={`${fieldPath}.${indexPath}.chemical_formula_reduced`} label="Reduced chemical formula" placeholder="CCaO3" description="The chemical formula for a structure as a string in a form chosen by the implementation. Please see: https://schemas.optimade.org/defs/v1.2/properties/optimade/structures/chemical_formula_reduced for property definition." /></Grid.Column>
                  <Grid.Column width="12"><Input fieldPath={`${fieldPath}.${indexPath}.chemical_formula_hill`} label="Hill chemical formula" placeholder="CCaO3" description="The chemical formula for a structure as a string in a form chosen by the implementation. Please see: https://schemas.optimade.org/defs/v1.2/properties/optimade/structures/chemical_formula_hill for property definition" /></Grid.Column>
                  <Grid.Column width="12"><Input fieldPath={`${fieldPath}.${indexPath}.chemical_formula_anonymous`} label="Anonymous chemical formula" placeholder="A3BC" description="The chemical formula for a structure as a string in a form chosen by the implementation. Please see: https://schemas.optimade.org/defs/v1.2/properties/optimade/structures/chemical_formula_anonymous for property definition." /></Grid.Column>
                  <Grid.Column width="12">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.number_of_elements`}
                    label="Number of elements"
                    placeholder="3"
                    description="Number of different elements in the structure as an integer. Please see: https://schemas.optimade.org/defs/v1.2/properties/optimade/structures/nelements for property definition."
                  />
                  </Grid.Column>
                  <Grid.Column width="12">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.weighted_pattern_r_factor`}
                    label="Weighted pattern R-factor (R_wp)"
                    placeholder="0"
                    description="A statistical measure of the quality of fit to a diffraction pattern. It is calculated by the square root of the weighted sum of the quotients of the differences between the calculated and observed diffraction pattern at each point and the weighted sum of squares of the observed pattern."
                  />
                  </Grid.Column>
                  <Grid.Column width="12">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.goodness_of_fit`}
                    label="Goodness of Fit"
                    placeholder="1"
                    description="A statistical measure of the quality of fit to a diffraction pattern. It is calculated by dividing the weighted pattern R-factor by the expected R-factor (R_exp)."
                  />
                  </Grid.Column>
                  <Grid.Column width="7">
                  <Input
                    fieldPath={`${fieldPath}.${indexPath}.maximum_intensity`}
                    label="Maximum Intensity"
                    placeholder="2044343.39"
                    description="The greatest value of intensity for each diffraction pattern, determined before any background subtraction."
                  />
                  </Grid.Column>

                </>
              )}

              {/* Flow Battery Reproducibility Study Fields (Simple Version - All Text Inputs) */}
              {selectedCategory === "Flow Battery" && (
                <>
                  {/* Section 1 - Opening Questions */}
                  {[
                    ["fb_data_collection_phase", "Data collection phase", "Phase 2a | Phase 2b | Phase 3", "Select the data collection phase that you are completing this form for."],
                    ["fb_participant_name", "Participant name", "[Title] [First name] [Last name]", "Full name of the person submitting the form. This information will be removed before data processing and sharing."],
                    ["fb_participant_institution", "Participant institution", "University of Example", "Institution of the participant. This information will be removed before data processing and sharing."],
                    ["fb_participant_department", "Participant department", "Department of Chemical Engineering", "Department or research unit of the participant. This information will be removed before data processing and sharing."],
                    ["fb_participant_email", "Participant email address", "b.researcher@example.edu", "Institutional e-mail address of the participant. This information will be removed before data processing and sharing."],
                    ["fb_participant_orcid", "Participant ORCID", "0000-0001-2345-6789", "ORCID identifier of the participant, if available. If not available, enter N/A."],
                    ["fb_job_role", "Job role", "Undergraduate student | Postgrad/PhD student | Staff | Industry researcher | Government researcher", "Option that best reflects role or position of the participant."],
                    ["fb_experience_flow_batteries", "Experience working with flow batteries", "< 6 months | 6-12 months | 1-2 years | 2-5 years | 5-10 years | > 10 years", "Approximate duration of experience carrying out physical flow battery experiments."],
                    ["fb_participant_identifier", "Participant identifier (PX)", "PX", "Participant identifier assigned by the study organisers."],
                    ["fb_number_of_repeats", "Number of repeats", "3", "How many testing repeats were completed successfully?"],
                  ].map(([key, fieldLabel, placeholder, desc]) => (
                    <Grid.Column width="7" key={key}>
                      <Input
                        fieldPath={`${fieldPath}.${indexPath}.${key}`}
                        label={fieldLabel}
                        placeholder={placeholder}
                        description={desc}
                      />
                    </Grid.Column>
                  ))}

                  {/* Section 2 - Electrode */}
                  {[
                    ["fb_electrode_pretreatment_type", "Electrode pre-treatment type", "None | Heat-treated", "High-level classification of electrode pre-treatment."],
                    ["fb_heat_treatment_furnace_type", "Heat treatment furnace type", "Muffle | Tube | Box | other", "Type of furnace used for electrode heat-treatment."],
                    ["fb_heat_treatment_furnace_details", "Heat treatment furnace details", "e.g., Nabertherm LE14/11", "Provide furnace make and model."],
                    ["fb_heat_treatment_atmosphere", "Heat treatment atmosphere", "Air | Inert gas | Vacuum | Other", "Atmosphere present during heat-treatment."],
                    ["fb_heat_treatment_ramp_rate", "Heat treatment ramp rate (°C/min)", "10", "Temperature ramp rate used to reach the target temperature."],
                    ["fb_heat_treatment_dwell_temperature", "Heat treatment dwell temperature (°C)", "400", "Maximum or dwell temperature applied during heat treatment."],
                    ["fb_heat_treatment_dwell_time", "Heat treatment dwell time (h)", "24", "Time held at dwell temperature (h)."],
                    ["fb_heat_treatment_cooling_method", "Heat treatment cooling method", "Passive | Forced air | Controlled ramp | other", "Cooling method following heat-treatment."],
                    ["fb_heat_treatment_cooling_details", "Heat treatment cooling details", "Furnace cooled to RT with door closed", "Describe any additional cooling details."],
                    ["fb_heat_treatment_batching", "Heat treatment batching", "Single batch | Treated individually before each test | other", "Whether electrodes were heat-treated as one batch or individually."],
                    ["fb_time_between_heat_treatment_and_use", "Time between heat treatment and use (h)", "24", "Approximate time (h) between completion of heat treatment and use."],
                    ["fb_electrode_storage_after_heat_treatment", "Electrode storage environment after heat treatment", "Open to air | Enclosed (non-inert) | Inert atmosphere | other", "Storage environment of electrodes between heat-treatment and use."],
                    ["fb_electrode_storage_after_receipt", "Electrode storage environment after receipt of cell kit", "Open to air | Enclosed (non-inert) | Inert atmosphere | other", "Storage environment of electrodes between receipt of cell test kit and use."],
                  ].map(([key, fieldLabel, placeholder, desc]) => (
                    <Grid.Column width="7" key={key}>
                      <Input
                        fieldPath={`${fieldPath}.${indexPath}.${key}`}
                        label={fieldLabel}
                        placeholder={placeholder}
                        description={desc}
                      />
                    </Grid.Column>
                  ))}

                  {/* Section 3 - Membrane */}
                  {[
                    ["fb_membrane_storage_type", "Membrane storage type between repeats", "Dry | Wet", "High-level storage condition(s) for membranes between repeats."],
                    ["fb_membrane_storage_liquid", "Liquid used for membrane storage between repeats", "Tap water | deionised H2O | distilled H2O | H2SO4 | Ferri/ferrocyanide solution | other", "What liquid was the membrane stored in between repeats."],
                    ["fb_membrane_storage_details", "Membrane storage details", "e.g., Stored in container included with test kit", "Provide extra information on the storage environment."],
                    ["fb_membrane_pretreatment", "Membrane pre-treatment?", "Yes | No (used as received)", "Did you pre-treat your membrane before use?"],
                    ["fb_membrane_pretreatment_steps", "Number of membrane pre-treatment steps", "2", "Enter the number of pretreatment steps performed."],
                    ["fb_membrane_pretreatment_applied", "Membrane pre-treatment applied", "Hydration only | electrolyte soaking | chemical cleaning/activation | ion exchange | conditioning in cell | other", "Select the option(s) that best describe any membrane pretreatment performed."],
                    ["fb_membrane_pretreatment_medium", "Membrane pre-treatment medium", "Deionised water | Potassium chloride solution | Potassium hydroxide solution | Sulfuric acid solution | Hydrogen peroxide solution | other", "High-level classification of membrane pre-treatment medium."],
                    ["fb_membrane_pretreatment_concentration", "Membrane pre-treatment medium concentration (M)", "1", "Provide concentration(s) (M) of electrode treatment media."],
                    ["fb_membrane_pretreatment_duration", "Membrane pre-treatment duration (h)", "24", "Approximate total duration (h) of membrane pre-treatment."],
                    ["fb_membrane_pretreatment_temperature", "Membrane pre-treatment temperature (°C)", "60", "Approximate temperature (°C) at which membrane pre-treatment was applied."],
                    ["fb_membrane_pretreatment_details", "Additional membrane pre-treatment details", "e.g., Pre-conditioning in cell carried out with electrolyte circulated at a flow rate of 50 mL/min", "Please provide additional pretreatment details."],
                  ].map(([key, fieldLabel, placeholder, desc]) => (
                    <Grid.Column width="7" key={key}>
                      <Input
                        fieldPath={`${fieldPath}.${indexPath}.${key}`}
                        label={fieldLabel}
                        placeholder={placeholder}
                        description={desc}
                      />
                    </Grid.Column>
                  ))}

                  {/* Section 4 - Electrolyte materials */}
                  {[
                    ["fb_ferrocyanide_chemical_details", "Potassium ferrocyanide chemical details", "Potassium hexacyanoferrate(II) trihydrate, K4Fe(CN)6 · 3H2O | other", "Chemical identity of the potassium ferrocyanide used."],
                    ["fb_ferrocyanide_purity", "Potassium ferrocyanide purity (%)", "98.5", "Nominal purity of the potassium ferrocyanide in percent (%)."],
                    ["fb_ferrocyanide_supplier", "Potassium ferrocyanide supplier", "Sigma Aldrich | Thermo Scientific | Fisher Chemical | Acros Organics | Merck | other", "Supplier or manufacturer of the potassium ferrocyanide."],
                    ["fb_ferricyanide_chemical_identity", "Potassium ferricyanide chemical identity", "Potassium ferricyanide(III), K3Fe(CN)6 | other", "Full chemical name of the potassium ferricyanide used."],
                    ["fb_ferricyanide_purity", "Potassium ferricyanide purity (%)", "98.5", "Nominal purity of the potassium ferricyanide in percent (%)."],
                    ["fb_ferricyanide_supplier", "Potassium ferricyanide supplier", "Sigma Aldrich | Thermo Scientific | Fisher Chemical | Acros Organics | Merck | other", "Supplier or manufacturer of the potassium ferricyanide."],
                    ["fb_supporting_electrolyte_identity", "Supporting electrolyte chemical identity", "Potassium chloride, KCl | other", "Chemical identity of the supporting electrolyte salt."],
                    ["fb_potassium_chloride_purity", "Potassium chloride purity (%)", "98.5", "Nominal purity of the electrolyte salt in percent (%)."],
                    ["fb_potassium_chloride_supplier", "Potassium chloride supplier", "Sigma Aldrich | Fisher Scientific | Fisher Chemical | Thermo Scientific | Merck | other", "Supplier or manufacturer of the electrolyte salt."],
                    ["fb_water_type", "Water type", "Deionised | Distilled | Tap | other", "General type of water used to produce electrolyte."],
                    ["fb_water_purification_system", "Water purification system", "Milli-Q (Merck) | Sartorius Arium | Thermo Scientific Barnstead | PURELAB | other | Unknown", "Water purification system or source."],
                    ["fb_water_purification_details", "Water purification system details", "SQ200 | Direct Q | Reference | Arium Mini | other | Unknown", "Optional system model or variant, if known."],
                    ["fb_water_resistivity", "Water resistivity (MΩ·cm)", "e.g. 18.2", "Water resistivity as indicated by purification system in MΩ·cm."],
                  ].map(([key, fieldLabel, placeholder, desc]) => (
                    <Grid.Column width="7" key={key}>
                      <Input
                        fieldPath={`${fieldPath}.${indexPath}.${key}`}
                        label={fieldLabel}
                        placeholder={placeholder}
                        description={desc}
                      />
                    </Grid.Column>
                  ))}

                  {/* Section 5 - Electrolyte preparation */}
                  {[
                    ["fb_electrolyte_preparation_strategy", "Electrolyte preparation strategy", "Single stock batch used across repeats | One batch per repeat | Multiple stock batches | Freshly prepared | other", "How electrolyte batches were prepared and allocated across experiments."],
                    ["fb_electrolyte_batch_size", "Electrolyte stock/batch size (mL)", "1000", "Provide the volume of the stock/batch size prepared for use."],
                    ["fb_electrolyte_storage_environment", "Electrolyte storage environment", "Dark (cupboard/covered) | ambient lab light | inert atmosphere | glovebox | other", "Select the option that best describes the electrolyte storage environment."],
                    ["fb_electrolyte_storage_duration", "Electrolyte storage duration (h)", "24", "The maximum duration (h) between electrolyte preparation and use in testing."],
                    ["fb_electrolyte_volume_measurement_method", "Electrolyte volume measurement method", "Volumetric | Gravimetric | Estimated | other", "Method used to measure the electrolyte volume."],
                    ["fb_volume_measurement_instrument", "Volume measurement instrument type", "Volumetric flask | Graduated cylinder | Pipette | Syringe | Pycnometer | Balance | other", "Instrument(s) used to measure electrolyte volume."],
                    ["fb_reagent_purity_used", "Reagent purity used in calculations", "Yes | No", "Whether supplier-reported reagent purity values were used."],
                    ["fb_reagent_purity_details", "Reagent purity usage details", "e.g., Mass was corrected using stated 99% purity", "Briefly describe how purity information was applied."],
                    ["fb_water_ph_measured", "Water pH measured", "Yes | No", "Whether the pH of the water used for electrolyte preparation was measured."],
                    ["fb_water_ph_value", "Water pH value", "e.g., 6.2", "Report the measured pH value."],
                    ["fb_electrolyte_ph_measured", "Electrolyte pH measured", "Yes | No", "Whether the pH of the prepared electrolyte was measured."],
                    ["fb_electrolyte_ph_value", "Electrolyte pH value", "e.g., 9.5", "Report the measured pH value."],
                  ].map(([key, fieldLabel, placeholder, desc]) => (
                    <Grid.Column width="7" key={key}>
                      <Input
                        fieldPath={`${fieldPath}.${indexPath}.${key}`}
                        label={fieldLabel}
                        placeholder={placeholder}
                        description={desc}
                      />
                    </Grid.Column>
                  ))}

                  {/* Section 6 - Cell and equipment setup */}
                  {[
                    ["fb_electrode_dimension_method", "Electrode dimension determination method", "Datasheet specifications | Template provided | Manual measurement | other", "How electrode dimensions were determined prior to cutting."],
                    ["fb_electrode_cutting_method", "Electrode cutting and sizing method", "Freehand manual cutting | Manual cutting using ruler | Template-guided | Punch or die cutting | Automated cutting | other", "How electrode dimensions were defined and the electrodes were cut."],
                    ["fb_potentiostat_usage", "Potentiostat usage", "Single instrument for all tests | Different instruments for some/all tests", "Whether one or multiple potentiostats were used."],
                    ["fb_potentiostat_manufacturer", "Potentiostat manufacturer", "Biologic | Metrohm Autolab | Gamry | Neware | Arbin | Ivium | other", "Manufacturer of the potentiostat or battery tester."],
                    ["fb_potentiostat_model", "Potentiostat model", "VSP-3e | VSP | VMP3 | SP-300 | PGSTAT302N | Reference 3000 | other", "Model of the potentiostat or battery tester."],
                    ["fb_potentiostat_calibration_frequency", "Potentiostat calibration frequency", "Weekly | Monthly | Yearly | Less frequently than yearly | Calibrated only when issues arise | Not calibrated | Unknown", "Whether the electrochemical instrument(s) is/are calibrated on a regular basis."],
                    ["fb_potentiostat_calibration_method", "Potentiostat calibration method", "Dummy cell (manufacturer supplied) | Dummy cell (third-party) | Manufacturer service | Automated internal procedure | other | Not applicable", "Method used to calibrate the instrument(s)."],
                    ["fb_connection_method", "Connection method to the cell", "Crocodile/alligator clips | Banana plug connection | Bolted/screw connection | other", "How potentiostat leads were connected to the current collectors."],
                    ["fb_electrical_connection_scheme", "Electrical connection scheme", "2-point (2-wire) | 4-point (4-wire) | other", "Whether voltage sense lines were separated from current-carrying lines."],
                    ["fb_potentiostat_cable_length", "Potentiostat cable length", "<1 m | 1-2 m | 2-3 m | >3 m | Unknown", "Approximate length of the potentiostat cable(s)."],
                    ["fb_potentiostat_cable_type", "Potentiostat cable type", "Manufacturer cable - standard length | Manufacturer cable - extended length | Third-party cable | Unknown", "Type of cable used between the potentiostat and the cell."],
                    ["fb_potentiostat_cable_shielding", "Potentiostat cable shielding", "Shielded | Unshielded | Mixed shielding | Unknown", "Whether the potentiostat cable(s) were shielded."],
                    ["fb_number_of_pumps", "Number of pumps used", "Single (including dual head) | Two separate pumps | other", "Number of pumps used in the experimental set-up."],
                    ["fb_pump_type", "Pump type", "Peristaltic | Syringe | Gear | Diaphragm | other", "General type of pump(s) used."],
                    ["fb_pump_manufacturer", "Pump manufacturer", "Masterflex (Cole-Parmer/Avantor) | Heidolph | Watson-Marlow | Lead Fluid | other", "Manufacturer of the pump(s) used."],
                    ["fb_pump_model", "Pump model", "BT100M | BT100-3J | Hei-FLOW Value 01 | Masterflex L/S Digital Drive | Watson-Marlow 120 | other", "Model of the pump(s) used."],
                    ["fb_reservoir_material", "Reservoir material", "Glass (borosilicate) | Polypropylene | PTFE | other", "Primary material of the electrolyte reservoir(s)."],
                    ["fb_reservoir_type", "Reservoir type", "Duran/Schott bottle (GL bottle) | Glass vial | Centrifuge tube | Custom tanks/other", "What best describes the reservoir tank used."],
                    ["fb_reservoir_volume", "Reservoir volume (mL)", "250", "Approximate maximum capacity (mL) of the reservoir tanks."],
                    ["fb_tubing_material", "Tubing material", "Norprene | PVC | PTFE | FEP | PFA | Silicone | Viton | polyethylene | other | Unknown", "Tubing material(s) used in the set-up."],
                    ["fb_tubing_manufacturer", "Tubing manufacturer", "Masterflex / Saint-Gobain | Thermo Scientific / Nalgene | McMaster-Carr | Swagelok | other | Unknown", "Manufacturer(s) of tubing used."],
                    ["fb_tubing_inner_diameter", "Tubing inner diameter", "≤1 mm | 1-2 mm | 2-3 mm | 3-4 mm | >4 mm", "Inner diameter(s) of tubing used."],
                    ["fb_wetted_fitting_materials", "Wetted fitting materials", "Polypropylene (PP) | PTFE | FEP | PFA | Stainless steel | PEEK | PVDF | other | None", "Materials of fittings in contact with electrolyte."],
                    ["fb_other_wetted_materials", "Other wetted materials", "Polypropylene (PP) | PTFE | FEP | PFA | Stainless steel | PEEK | PVDF | other | None", "Any other wetted materials in your system."],
                    ["fb_electrolyte_volume_used", "Electrolyte volume used (mL)", "50", "Volume of electrolyte used (per reservoir) in mL."],
                    ["fb_impedance_reservoir_config", "Impedance reservoir configuration", "Single reservoir | Double reservoir", "Reservoir configuration used during impedance measurements."],
                    ["fb_polarisation_reservoir_config", "Polarisation reservoir configuration", "Single reservoir | Double reservoir", "Reservoir configuration used during polarisation measurements."],
                    ["fb_electrolyte_flow_rate", "Electrolyte flow rate (mL/min)", "50", "What electrolyte flow rate(s) were used for testing."],
                  ].map(([key, fieldLabel, placeholder, desc]) => (
                    <Grid.Column width="7" key={key}>
                      <Input
                        fieldPath={`${fieldPath}.${indexPath}.${key}`}
                        label={fieldLabel}
                        placeholder={placeholder}
                        description={desc}
                      />
                    </Grid.Column>
                  ))}

                  {/* Section 7 - Experimental methods and observations */}
                  {[
                    ["fb_temperature_control", "Temperature control", "Temperature controlled | Ambient (not controlled)", "Whether the experiment temperature was actively controlled or ambient."],
                    ["fb_laboratory_temperature", "Laboratory temperature", "≤18 °C | 18-20 °C | 20-22 °C | 22-24 °C | 24-26 °C | >26 °C | variable | Not recorded", "Typical laboratory temperature during experiments."],
                    ["fb_pump_flow_rate_calibrated", "Pump flow rate calibrated", "Yes | No", "Whether the pump flow rate was calibrated for these experiments."],
                    ["fb_calibration_with_cell", "Calibration performed with cell in line", "Yes | No | Both | Unknown", "Whether calibration was performed with the flow cell connected."],
                    ["fb_calibration_fluid", "Calibration fluid used", "Water | Electrolyte | Both", "Fluid used during pump calibration."],
                    ["fb_pump_recalibrated", "Pump recalibrated during experiments", "Yes | No | Unknown", "Whether pump flow rate was re-checked or recalibrated during the campaign."],
                    ["fb_pump_calibration_method", "Pump calibration method", "Manual volumetric | Manual gravimetric | Automated instrument routine | Calibration curve | other", "Method used to calibrate pump flow rate."],
                    ["fb_leak_test_performed", "Leak test performed", "Yes | No", "Was a leak test performed with water before electrochemical testing began?"],
                    ["fb_leak_test_duration", "Leak test duration (h)", "1", "What was the duration (h) of the leak test?"],
                    ["fb_leak_test_flow_rate", "Leak test flow rate (mL/min)", "50", "What was the flow rate (mL/min) applied during the leak test?"],
                    ["fb_break_in_performed", "Pre-conditioning/break-in/rest period performed", "Yes | No", "Was a pre-conditioning or break-in period performed?"],
                    ["fb_break_in_duration", "Break-in period duration (h)", "1", "What was the duration (h) of this period?"],
                    ["fb_break_in_flow_rate", "Break-in period flow rate (mL/min)", "50", "What was the flow rate (mL/min) applied during this period?"],
                    ["fb_cell_assembly_issues", "Cell assembly issues", "No | Yes (please specify)", "Did you encounter any challenges or issues when using the supplied flow cell?"],
                    ["fb_additional_experiments", "Additional experiments performed", "Yes | No", "Whether any additional experiments were carried out beyond the requested repeats."],
                    ["fb_additional_experiment_rationale", "Additional experiment rationale", "Leak or sealing issue | Equipment or software failure | Protocol error | Incorrect measurement settings | Material defect | other", "Reason for performing additional repeats."],
                    ["fb_leakage_location", "Leakage location", "Cell | System (tubing, tanks, etc.)", "Did the electrolyte leakage occur from the cell or from some part of the system?"],
                    ["fb_repeats_techniques_repeated", "Repeat(s) and technique(s) repeated", "Repeat 1 - polarisation | Repeat 1 - impedance | Repeat 1 - cycling | Repeat 2 - polarisation | etc.", "Which repeat(s) and technique(s) were carried out more than once?"],
                    ["fb_repeat_method", "Repeat method", "Full cell disassembly and rebuild, same electrolyte | Full cell disassembly and rebuild, fresh electrolyte | Cell kept assembled, electrolyte replaced | Cell and electrolyte unchanged", "Select the most representative method used."],
                    ["fb_electrolyte_leakage_reported", "Electrolyte leakage (reported data only)", "No | Yes", "Did any amount of electrolyte leak from the cell or system when obtaining the reported data?"],
                    ["fb_leakage_description", "Leakage description (reported data only)", "Sweating / crust formation | Isolated droplets | Continuous dripping | Bulk loss", "How would you describe the leakage that occurred?"],
                    ["fb_leak_severity", "Leak severity (reported data only)", "Minor leakage | Moderate leakage | Major leakage", "Describe leak severity."],
                    ["fb_leakage_volume", "Leakage volume (mL)", "<0.5 mL | 0.5-1 mL | 1-2 mL | 2-5 mL | 5-10 mL | 10-25 mL | >25 mL | Unsure", "Estimate the volume of electrolyte that leaked."],
                    ["fb_typical_group_practice_leaks", "Typical group practice for leaking cells", "Tolerate minor leaks (documentation unnecessary) | Tolerate minor leaks but document | Discard data if any leak occurs | Case-by-case decision | other", "How your group would generally treat data from leaking cells."],
                    ["fb_electrolyte_stirring", "Electrolyte stirring performed", "Yes | No", "Whether the electrolyte in the reservoirs was actively stirred."],
                    ["fb_reservoir_stirring_method", "Reservoir stirring method", "Magnetic stir bar | Overhead stirrer | other", "Select the primary stirring method used."],
                    ["fb_stirring_rate", "Stirring rate (RPM)", "<100 RPM | 100-200 RPM | 200-400 RPM | 400-600 RPM | 600-1000 RPM | >1000 RPM | Not recorded", "Approximate stirring speed."],
                    ["fb_electrolyte_sparging", "Electrolyte sparging performed", "Yes | No", "Whether the electrolyte was sparged with an inert gas."],
                    ["fb_sparging_gas", "Sparging gas", "Nitrogen | Argon | other", "Select the inert gas used."],
                    ["fb_gas_humidification", "Gas humidification", "Humidified | Not humidified", "Whether the sparging gas was humidified."],
                    ["fb_sparging_application", "Sparging application", "Pre-sparge only | Continuous sparging | Pre-sparge then headspace blanket | Headspace blanket only", "How sparging or inert gas exposure was applied."],
                    ["fb_sparging_gas_flow_rate", "Sparging gas flow rate", "<5 mL/min | 5-10 mL/min | 10-25 mL/min | >25 mL/min | Not recorded", "Approximate gas flow rate used during sparging."],
                    ["fb_polarisation_beyond_limits", "Polarisation beyond ±25 mA/cm²", "Yes | No", "Whether you measured polarisation beyond the specified current density limits."],
                    ["fb_max_current_density", "Maximum current density used (mA/cm²)", "e.g. 50", "The highest current density (mA/cm²) reached."],
                    ["fb_max_current_density_rationale", "Rationale for maximum current density", "e.g. Instrument limits", "How did you determine the maximum current applied?"],
                    ["fb_impedance_control_mode", "Impedance control mode", "Potentiostatic (PEIS) | Galvanostatic (GEIS)", "Control mode used for electrochemical impedance spectroscopy."],
                    ["fb_impedance_technique_rationale", "Rationale for impedance technique", "Standard practice in group/lab | Better control of potential / SOC | Greater familiarity with technique | Linearity and signal quality | Followed experimental procedure from literature | other", "Reason(s) for choosing this impedance control mode."],
                    ["fb_impedance_parameters_basis", "Basis for selecting impedance parameters", "Followed experimental procedure from literature | Standard instrument defaults | Standard practice in group/lab | Prior experience with similar systems | Exploratory adjustment | other", "How unspecified impedance parameters were chosen."],
                    ["fb_reservoir_tubing_changes", "Reservoir/tubing changes observed during cycling", "None observed | Evaporation | Volume imbalance | Colour change | Precipitation | Condensation on walls | Staining in tank | Staining of tubing | other", "Observed changes to reservoirs during cycling."],
                    ["fb_observable_changes_disassembly", "Observable changes after cell disassembly", "None observed | Component discolouration | Solid deposits / precipitates | Leakage residue / crusts | Membrane deformation or stiffening | Electrode surface impressions | other", "Observed changes after disassembling the cell."],
                    ["fb_components_affected", "Components affected", "Membrane | Electrodes | Gaskets | flow fields / current collectors", "Identify which cell components showed observable changes."],
                    ["fb_discolouration_nature", "Nature of discolouration or deposits", "Blue / green staining | Yellow / orange staining | Salt crystallisation | Prussian-blue-like deposits | other", "Select the closest description."],
                    ["fb_additional_tests_performed", "Additional tests performed", "e.g., Conductivity check after cycling", "Describe any additional evaluations performed beyond the requested protocol."],
                  ].map(([key, fieldLabel, placeholder, desc]) => (
                    <Grid.Column width="7" key={key}>
                      <Input
                        fieldPath={`${fieldPath}.${indexPath}.${key}`}
                        label={fieldLabel}
                        placeholder={placeholder}
                        description={desc}
                      />
                    </Grid.Column>
                  ))}

                  {/* Section 8 - Closing questions */}
                  {[
                    ["fb_consent_public_display", "Consent to public display of dataset and metadata", "Yes | No | other", "Consent for all experimental data and metadata to be displayed on a publicly accessible online dashboard."],
                    ["fb_consent_clarification", "Consent clarification (if other selected)", "Share data but exclude free-text fields", "Briefly describe any conditions or limitations on public display of your data."],
                    ["fb_additional_protocol_details", "Additional protocol or setup details", "No additional details", "Any further information about your protocol or cell configuration."],
                    ["fb_additional_documentation_uploaded", "Additional documentation or photographs uploaded", "Yes | No", "Indicates whether additional documentation or photographs were uploaded with this submission."],
                  ].map(([key, fieldLabel, placeholder, desc]) => (
                    <Grid.Column width="7" key={key}>
                      <Input
                        fieldPath={`${fieldPath}.${indexPath}.${key}`}
                        label={fieldLabel}
                        placeholder={placeholder}
                        description={desc}
                      />
                    </Grid.Column>
                  ))}
                </>
              )}
            </Grid>
          )}
        </Array>
      </Form>
    );
  }
}
